/**
 * Loading placeholder block.
 *
 * A skeleton is only worth rendering when it occupies the SAME geometry as the
 * content it stands in for — otherwise it trades a spinner-shaped layout shift
 * for a skeleton-shaped one. Callers size each block to match its real
 * counterpart (`h-4 w-24`, etc.) rather than reaching for a generic "card".
 *
 * The pulse animates `opacity` only (compositor-friendly, no reflow) and is
 * disabled under `prefers-reduced-motion` — see `.skeleton-block` in
 * apps/web/src/index.css, which owns the visual so the surface tint tracks the
 * active theme's CSS variables.
 *
 * `aria-hidden` because a screen reader should hear the container's `aria-busy`
 * state, not a stack of meaningless empty boxes.
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden="true" className={`skeleton-block ${className}`} />
}
